import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { syncUniversityTheme } from "@/lib/theme/tenantTheme";
import { isNetworkFetchError } from "@/features/auth/utils/isNetworkFetchError";

const VITE_CLIENT_FUNCTION_BASE_URL = import.meta.env
  .VITE_CLIENT_FUNCTION_BASE_URL;

export const useUniversity = () => {
  const [university, setUniversity] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUniversity = async () => {
      try {
        /*
        development-client.meritcurve.com
        meritcurve-dev.web.app
        demo-candidate.meritcurve.com
        learn-kgisl.microcollege.in
        ace.meritcurve.com
        learn.meritcurve.com
        www.vedic.dev
        learn.logicwhile.com
        learn.thecodenow.in
        jobseeker.jobportal.mat-hub.ai  
        www.bytsone.com
      */
        const domain =
          import.meta.env.MODE === "development"
            ? "www.vedic.dev"
            : // "learn.meritcurve.com"
            window.location.host;

        const response = await fetch(
          `${VITE_CLIENT_FUNCTION_BASE_URL}/university?domain=${domain}`
        );

        if (response.status === 404) {
          throw new Error(
            "University not found. Please check the URL you entered and try again."
          );
        }

        if (!response.ok) {
          throw new Error(`Failed to fetch university: ${response.status}`);
        }

        const data = await response.json();

        if (data?.university?.config?.ui_disable) {
          throw new Error(
            "Account is disabled, please reach out to support team"
          );
        }

        const nextUniversity = data?.university ?? null;
        // Apply + cache tenant colors; never throws
        // primary ← primary_color; brandAccent ← secondary_color; --secondary stays muted zinc
        syncUniversityTheme(nextUniversity);
        setUniversity(nextUniversity);
      } catch (error) {
        setError(error);
        // Full-page ConnectionIssues UI handles network/provider blocks
        if (!isNetworkFetchError(error)) {
          toast.error(
            error.message || "Failed to load university configuration"
          );
        }
        console.error("University fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUniversity();
  }, []);

  return { university, loading, error };
};
